import { TypographyH4, TypographyP } from '@talentmesh/ui/components/typography';
import type { WorkArrangements } from '@talentmesh/utils';
import { useWatch } from 'react-hook-form';

import { JobDetailsFieldTypes } from '../../JobDetailsStepUtils';
import UIStrings from '@/Utils/UIStrings';

function JobLocationTooltipBody() {
    const workArrangement: WorkArrangements = useWatch({ name: JobDetailsFieldTypes.WorkArrangement });

    return (
        <div className="flex max-w-sm flex-col gap-2">
            <TypographyH4 className="text-foreground">
                {workArrangement === 'Remote' ? UIStrings.RemoteTooltipTitle : UIStrings.OnLocationTooltipTitle}
            </TypographyH4>
            <TypographyP className="text-foreground">
                {workArrangement === 'Remote'
                    ? UIStrings.RemoteTooltipDescription
                    : UIStrings.OnLocationTooltipDescription}
            </TypographyP>
        </div>
    );
}

export default JobLocationTooltipBody;
